import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/ic_close@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-6be031f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "content_search content_top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "close",
  src: _imports_0,
  alt: "",
  style: {"opacity":"0"}
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选择物料", -1))
const _hoisted_5 = { class: "content_total" }
const _hoisted_6 = { class: "fp_list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "fp_list_item_box" }
const _hoisted_9 = { class: "fp_list_item_header" }
const _hoisted_10 = {
  key: 0,
  class: "green"
}
const _hoisted_11 = {
  key: 1,
  class: "yellow"
}
const _hoisted_12 = {
  key: 2,
  class: "red"
}
const _hoisted_13 = { class: "loacing" }
const _hoisted_14 = ["checked"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_zw" }, null, -1))

import { onMounted, ref, reactive, watch } from 'vue'
    import { choiceStockListPage } from '@/apis/agencyAPI'
    import { model } from '@/interface'
    import { judgmentPlatform } from "@/utils/utils"
    import vSearch from '@/components/common/Search.vue'

    // 搜索数据接口
    interface form extends model {
        total: number,
        smodelLabel: string,
        categoryId: string
    }

    
export default /*#__PURE__*/_defineComponent({
  props: {
        show: {
            type: Boolean,
            required: true
        },
        id: {
            type: String,
            required: false
        },
        warehouseQualityType: {
            type: String,
            required: false
        }
    },
  emits: ['close', 'value'],
  setup(__props, { expose, emit }) {

const props = __props

    const form = reactive<form>({
        capacity: 50,
        page: 0,
        total: 0,
        smodelLabel: '',
        categoryId: ''
    })

    // 搜索分类标签
    let tagList = ref<Array<{id: string, name: string, num: string}>>([])

    // 列表数据
    const list: any = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false)
    const V = ref(null)
    let isOpen = ref<boolean>(true)
    let all = ref<boolean>(false)
    let total = ref<number>(0)
    let selected = ref<Array<any>>([])

    // 提交数据
    const submitData = () => {
        let arr: Array<any> = []
        list.value.forEach((element: any) => {
            if (element.isActive) {
                arr.push(element)
            }
        })
        emit('value', arr)
    }

    // 全选
    const selectAll = () => {
        all.value = !all.value
        list.value.forEach((element: any) => {
            element.isActive = all.value
        })
    }

    const test = () => {
        const { text }: any = V.value
        form.smodelLabel = ''
        V.value.text = ''
    }

    const clickTag = (tag: string): void => {
        form.categoryId = tag
        list.value = []
        finished.value = false
        form.page = 0
        form.total = 0
        onLoad()
    }

    // 搜索框
    const searchInput = (data: any) => {
        form.page = 0
        finished.value = false
        list.value = []
        form.smodelLabel = data
        onLoad()
    }

    // 搜索提交
    const submit = (): void => {
        form.page = 0
        finished.value = false
        list.value = []
        onLoad()
    }

    // 返回上一页带参数
    const jump = (item: any) => {
        item.isActive = !item.isActive
    }

    // 获取工单列表数据
    const onLoad = async () => {
        if (!finished.value) {
            loading.value = true;
            form.page = form.page + 1
            choiceStockListPage({
                capacity: form.capacity,
                page: form.page,
                model: {
                    warehouseId: props.id,
                    warehouseQualityType: props.warehouseQualityType,
                    ids: selected.value.length > 0 ? selected.value.join(',') : ''
                }
            }).then(res => {
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
                loading.value = false;
                if (res.code === 200 && res.data.records && res.data.records.length !== 0) {
                    form.total = res.data.total
                    res.data.records.forEach((element: any) => {
                        element.isActive = false
                    })
                    // if (selected.value.length > 0) {
                    //     selected.value.forEach((id: any) => {
                    //         res.data.records.forEach((element: any, index: number) => {
                    //             if (id === element.materialId) {
                    //                 res.data.records.splice(index, 1)
                    //             }
                    //         })
                    //     })
                    // }
                    list.value.push(...res.data.records)
                } else {
                    finished.value = true;
                }
            }).catch((err: any) => {
                loading.value = false;
                finished.value = true;
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
            })
        }
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        finished.value = false;
        form.page = 0
        loading.value = true;
        onLoad()
    }

    

    

    let status = ref<boolean>(false)

    // 关闭回调
    const close = () => {
        emit('close')
    }

    watch(() => list.value, (news) => {
        if (list.value.length > 0) {
            total.value = 0
            list.value.forEach((element: any) => {
                if (element.isActive) {
                    total.value = total.value + 1
                }
            })
        }
    }, { deep: true })

    watch(() => props.show, (news) => {
        if (!news) {
            test()
        } else {
            if (!isOpen.value) {
                list.value = []
                finished.value = false;
                form.page = 0
                loading.value = true;
                onLoad()
            }
            isOpen.value = false
        }
    })

    expose({
        selected
    })

    onMounted(() => {
        status.value = judgmentPlatform()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: props.show,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((props.show) = $event)),
    "close-on-click-overlay": false,
    position: "bottom",
    round: "",
    style: { height: '80%' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", { class: "title1" }, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("img", {
              class: "close",
              src: _imports_0,
              alt: "",
              onClick: close
            })
          ]),
          _createVNode(vSearch, {
            ref_key: "V",
            ref: V,
            onSearchInput: searchInput,
            onSubmit: submit,
            isShow: false,
            placeholder: "搜索物料名称"
          }, null, 512)
        ]),
        _createElementVNode("div", _hoisted_5, "共" + _toDisplayString(_unref(form).total) + "条数据", 1),
        _createVNode(_component_van_pull_refresh, {
          modelValue: refreshing.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
          onRefresh: onRefresh
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_list, {
              loading: loading.value,
              "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
              finished: finished.value,
              "finished-text": "没有更多了~",
              onLoad: onLoad
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "fp_list_item",
                      key: i,
                      onClick: ($event: any) => (jump(item))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", null, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1),
                          _createElementVNode("span", null, [
                            (item.qualityType === '0')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "合格"))
                              : _createCommentVNode("", true),
                            (item.qualityType === '1')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "不良"))
                              : _createCommentVNode("", true),
                            (item.qualityType === '2')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "报废"))
                              : _createCommentVNode("", true),
                            _createTextVNode(" ｜" + _toDisplayString(item.procedureName ? item.procedureName : '-') + "｜" + _toDisplayString(item.batch ? item.batch : '-'), 1)
                          ]),
                          _createElementVNode("span", _hoisted_13, "货位：" + _toDisplayString(item.locationName), 1)
                        ])
                      ]),
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: item.isActive
                      }, null, 8, _hoisted_14)
                    ], 8, _hoisted_7))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["loading", "finished"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_15,
        _createElementVNode("div", { class: "content_footer" }, [
          _createElementVNode("div", {
            class: "content_footer_submit",
            onClick: submitData
          }, "确认选择")
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})